<template>
  <div class="about">
    <div class="about-body">
      <div class="about-left">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          @select="handleMenuItemClick"
          background-color="rgb(230, 230, 230)"
        >
          <el-menu-item index="1">
            <i class="el-icon-house"></i>
            <span slot="title">公司简介</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-collection-tag"></i>
            <span slot="title">公司文化</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-medal"></i>
            <span slot="title">公司荣誉</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="about-right">
        <div v-show="!isShowRy">
          <ComputerItem :data="newsData1[0]" />
        </div>
        <div v-show="isShowRy">
          <ImageGallery
            :patent-images="patentImages"
            :software-images="softwareImages"
            :article-images="articleImages"
          />
        </div>
      </div>
    </div>

    <SiteFooter />
  </div>
</template>

<script>
  import SiteFooter from '../components/SiteFooter.vue'
  import ComputerItem from '../components/ComputerItem.vue'
  import ImageGallery from '../components/ImageGallery.vue'
  export default {
    components: { SiteFooter, ComputerItem, ImageGallery },
    data() {
      return {
        isShowRy: false,
        activeIndex: '1',
        //测试数据
        newsData1: [
          {
            id: 1,
            title: '公司简介',
            time: '2023-07-07 17:46:00',
            text: [
              '河南郑大水利科技有限公司，成立于2019年4月15日，位于河南省郑州市高新技术开发区郑州大学大学科技园2号楼，是一家依托于高校师资力量和科研平台，以软件开发、科研成果转化、技术咨询与服务为主营业务的公司。现有专兼职人员10余名，硕士及以上学历占比90%以上，中高级职称占比80%以上。'
            ],
            images: ''
          }
        ],
        //专利证书图片数组
        patentImages: [
          require('@/assets/images/honour/honour1/一种基于出力调节的径流式水电站自动优化方法.jpg'),
          require('@/assets/images/honour/honour1/一种径流引水式水电站用生态流量远程监控系统.jpg'),
          require('@/assets/images/honour/honour1/一种生态流量的监控固定装置.jpg'),
          require('@/assets/images/honour/honour1/一种生态流量监控设备的移动固定装置.jpg')
          // require("@/assets/images/honour/honour1/一种基于出力调节的径流式水电站自动优化方法.jpg"),
          // require("@/assets/images/honour/honour1/一种径流引水式水电站用生态流量远程监控系统.jpg"),
          // require("@/assets/images/honour/honour1/一种生态流量的监控固定装置.jpg"),
          // require("@/assets/images/honour/honour1/一种生态流量监控设备的移动固定装置.jpg"),
          // require("@/assets/images/honour/honour1/一种基于出力调节的径流式水电站自动优化方法.jpg"),
          // require("@/assets/images/honour/honour1/一种径流引水式水电站用生态流量远程监控系统.jpg"),
          // require("@/assets/images/honour/honour1/一种生态流量的监控固定装置.jpg"),
          // require("@/assets/images/honour/honour1/一种生态流量监控设备的移动固定装置.jpg"),
        ],
        //软件著作图片数组
        softwareImages: [
          require('@/assets/images/honour/honour2/大体积混凝土温度应力场仿真计算软件证书.jpg'),
          require('@/assets/images/honour/honour2/陆浑水库水电站厂内经济运行管理系统证书.jpg'),
          require('@/assets/images/honour/honour2/陆浑水库水电站优化调度系统证书.jpg'),
          require('@/assets/images/honour/honour2/水能计算软件证书.jpg')
        ],
        //文章成果图片数组
        articleImages: [
          require('@/assets/images/honour/honour3/基于开度控制的水电站厂内经济运行模型研究.png'),
          require('@/assets/images/honour/honour3/基于组件技术的水电站厂内经济运行系统.png'),
          require('@/assets/images/honour/honour3/监控平台下燕山水电站经济运行应用系统研究.png'),
          require('@/assets/images/honour/honour3/微粒群算法在水轮机导叶分段关闭折点寻优中的应用研究.png')
        ]
      }
    },
    methods: {
      handleMenuItemClick(index, indexPath) {
        console.log('点击了菜单项:', index, indexPath)
        // 在这里添加你的点击处理逻辑

        if (index === '1') {
          this.isShowRy = false
          this.newsData1[0].title = '公司简介'
          this.newsData1[0].text = [
            '河南郑大水利科技有限公司，成立于2019年4月15日，位于河南省郑州市高新技术开发区郑州大学大学科技园2号楼，是一家依托于高校师资力量和科研平台，以软件开发、科研成果转化、技术咨询与服务为主营业务的公司。现有专兼职人员10余名，硕士及以上学历占比90%以上，中高级职称占比80%以上。'
          ]
        } else if (index === '2') {
          this.isShowRy = false
          this.newsData1[0].title = '公司文化'
          this.newsData1[0].text = [
            '公司依托郑州大学知识力量和创新技术，面向水利行业，进行产学研技术转化并推向市场，为水利行业提供整体技术解决方案和服务。',
            '望与行业同仁携手推进水利行业的发展。'
          ]
        } else {
          this.isShowRy = true
          console.log('11111')
        }
      }
    }
  }
</script>

<style scoped>
  .about {
    width: 100%;
    height: 590px;
    margin: 20px 0 0 0;
  }
  .about-body {
    display: flex;
    justify-content: space-between;
  }
  .about-left {
    width: 25%;
    height: 590px;
    background-color: rgb(230, 230, 230);
    border-right: 1px solid #ededed;
  }
  .about-right {
    width: 75%;
    height: 590px;
    background-color: rgb(230, 230, 230);
  }
  .el-menu-vertical-demo {
    height: 90%;
    margin: 20px;
  }
</style>
